import { render } from "./Limited.vue?vue&type=template&id=08e19e5b"
import script from "./Limited.vue?vue&type=script&lang=js"
export * from "./Limited.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__